import { Component, OnInit } from '@angular/core';
import { UserInfo } from '../core/ucr-security/user-info';
import { UcrSecurityService } from '../core/ucr-security/ucr-security.service';
import { HttpClient } from '@angular/common/http';
import { Roles } from '../core/ucr-security/roles';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import {HealthService} from "../shared/services/health.service";
@Component({
    selector: 'app-registrar',
    templateUrl: './registrar.component.html',
    styleUrls: ['./registrar.component.scss']
})
export class RegistrarComponent implements OnInit {
    readonly roles = Roles;

    userInfo: UserInfo;
    environment: any = environment;

    constructor(
        private ucrSecurityService: UcrSecurityService,
        private http: HttpClient,
        public route: ActivatedRoute,
        public health: HealthService
    ) {
        this.ucrSecurityService.getUserInfo().subscribe((ui: UserInfo) => {
            this.userInfo = ui;
        });
    }

    ngOnInit(): void {
    }
}
